import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pr-2" }
const _hoisted_2 = { class: "w-[38rem] h-[40rem] self-center" }
const _hoisted_3 = { class: "text-v_dark_blue" }
const _hoisted_4 = { class: "flex justify-between items-center text-v_dark_gray mt-5" }
const _hoisted_5 = { class: "text-v_dark_gray mt-4" }
const _hoisted_6 = { class: "text-v_dark_gray mt-4" }
const _hoisted_7 = { class: "mt-10 flex justify-between items-center" }

import { ref, watch, reactive } from "vue"
import {
	ModalContainer,
	H1,
	H2,
	Input,
	ModalCloseButton,
	ModalButton,
	ModalContentContainer,
} from "../atoms"
import { IResale } from "@/utils/interfaces"
import { createUser } from "@/repositories/users"
import { Notification } from "@/utils/enum"


export default /*#__PURE__*/_defineComponent({
  __name: 'NewUserModal',
  emits: [
	"enableLoading",
	"emitError",
	"success",
	"closeNewUserModal",
],
  setup(__props, { emit }) {

/* eslint-disable  no-useless-escape */
let showButton = ref(false)



let user: IResale = reactive({
	name: "",
	resaleCode: "",
	email: "",
	username: "",
})

watch(user, () => {
	let validade = []

	const regex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(user.email)

	for (const key in user) {
		if (user[key as keyof IResale] != "" && regex) {
			validade.push(key)
		}
	}

	if (validade.length == 4) {
		showButton.value = true
	} else {
		showButton.value = false
	}
})

const createNewUser = async () => {
	emit("enableLoading", true)

	const res: any = await createUser(user)

	if (res?.status == 201) {
		emit(
			"success",
			true,
			Notification.TITLE_REGISTERED_USER,
			Notification.SUBTITLE_REGISTERED_USE
		)
	} else if (res?.status == 404) {
		emit(
			"emitError",
			true,
			Notification.TITLE_CODE_NOT_FOUND,
			Notification.SUBTITLE_CODE_NOT_FOUND
		)
	} else if (res?.status == 400) {
		emit(
			"emitError",
			true,
			Notification.TITLE_EXISTING_USER,
			Notification.SUBTITLE_EXISTING_USER
		)
	} else if (res?.response.status >= 500) {
		emit(
			"emitError",
			true,
			Notification.TITLE_ERROR,
			Notification.SUBTITLE_ERROR
		)
	}

	emit("closeNewUserModal", false)
	emit("enableLoading", false)
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createBlock(_unref(ModalContainer), null, {
    default: _withCtx(() => [
      _createVNode(_unref(ModalContentContainer), { width: 15 }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("button", {
              class: "px-2 py-2 float-right w-8 active:scale-90",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('closeNewUserModal', false)))
            }, [
              _createVNode(_component_v_icon, { icon: "mdi-close-thick" })
            ])
          ]),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_unref(H1), null, {
                default: _withCtx(() => [
                  _createTextVNode("Novo Usuário")
                ]),
                _: 1
              }),
              _createVNode(_unref(H2), { class: "text-black opacity-[50%] text-left" }, {
                default: _withCtx(() => [
                  _createTextVNode(" Preencha todos os campos corretamente para criar um novo usuário ")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", null, [
                _createVNode(_unref(H2), { class: "text-left font-[700]" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Nome de usuário:")
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Input), {
                  type: "text",
                  class: "mt-2",
                  modelValue: _unref(user).username,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(user).username) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", null, [
                _createVNode(_unref(H2), { class: "text-left font-[700]" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Código Revenda:")
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Input), {
                  type: "text",
                  class: "mt-2",
                  modelValue: _unref(user).resaleCode,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(user).resaleCode) = $event))
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_unref(H2), { class: "text-left font-[700]" }, {
                default: _withCtx(() => [
                  _createTextVNode("Nome Revenda:")
                ]),
                _: 1
              }),
              _createVNode(_unref(Input), {
                w: "38rem",
                class: "mt-2",
                modelValue: _unref(user).name,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(user).name) = $event)),
                type: "text"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_unref(H2), { class: "text-left font-[700]" }, {
                default: _withCtx(() => [
                  _createTextVNode("Email:")
                ]),
                _: 1
              }),
              _createVNode(_unref(Input), {
                w: "38rem",
                class: "mt-2",
                modelValue: _unref(user).email,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(user).email) = $event)),
                type: "email"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_unref(ModalCloseButton), {
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('closeNewUserModal', false))),
                class: "active:scale-90",
                enableButton: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Cancelar ")
                ]),
                _: 1
              }),
              _createVNode(_unref(ModalButton), {
                disabled: !_unref(showButton),
                class: "active:scale-90",
                enableButton: _unref(showButton),
                onClick: createNewUser
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Criar ")
                ]),
                _: 1
              }, 8, ["disabled", "enableButton"])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})